/* eslint-disable camelcase */
import {
  SET_BUSINESS_PAGE,
  CHANGE_MODAL_EMAIL,
  CHANGE_MODAL_NAME,
  CHANGE_MODAL_MESSAGE,
  SEND_MODAL_FORM_RESPONSE,
  BUSINESS_PAGE_RESET,
} from "../constants/ActionTypes";

const INIT_STATE = {
  name: "",
  description: "",
  logo: "",
  links: [],
  business_locations: [
    {
      address: "",
      photos: [],
      employees_working: [],
      services_offered: [],
      operations: {
        monday: undefined,
        tuesday: undefined,
        wednesday: undefined,
        thursday: undefined,
        friday: undefined,
        saturday: undefined,
        sunday: undefined,
      },
    },
  ],
  owner_details:[],
  photos:[],
  modalName: "",
  modalEmail: "",
  modalMessage: "",
  business_slug: "",
  website:"",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_BUSINESS_PAGE: {
      const {
        name,
        description,
        logo,
        business_locations,
        links,
        business_slug,
        photos,
        owner_details,
        website
      } = action.payload[0];
    
      return {
        ...state,
        name,
        description,
        logo,
        links,
        business_slug,
        business_locations,
        photos,
        owner_details,
        website
      };
    }

    case CHANGE_MODAL_NAME:
      return {
        ...state,
        modalName: action.payload,
      };
    case CHANGE_MODAL_EMAIL:
      return {
        ...state,
        modalEmail: action.payload,
      };
    case CHANGE_MODAL_MESSAGE:
      return {
        ...state,
        modalMessage: action.payload,
      };

    case SEND_MODAL_FORM_RESPONSE:
      return {
        ...state,
        modalName: "",
        modalEmail: "",
        modalMessage: "",
      };

    case BUSINESS_PAGE_RESET:
      return { ...INIT_STATE };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/BusinessPage.js